import supabase from '../supabase/client';
import uazApiService from '../services/UazApiService';

export class InstanceStatusSync {
  private static syncInterval: NodeJS.Timeout | null = null;
  private static isSyncing = false;

  static async syncAllInstances(): Promise<void> {
    if (this.isSyncing) {
      return;
    }

    try {
      this.isSyncing = true;
      
      const { data: instances, error } = await supabase
        .from('instances')
        .select('*')
        .order('name');
      
      if (error) {
        return;
      }
      
      if (!instances || instances.length === 0) {
        return;
      }
      
      for (const instance of instances) {
        try {
          const statusResult = await uazApiService.getInstanceStatus(instance.whatsapp);
          
          let isConnected = false;
          let currentStatus = 'disconnected';
          
          if (statusResult.success && statusResult.data?.instance) {
            currentStatus = statusResult.data.instance.status;
            isConnected = currentStatus === 'connected';
          } else {
            isConnected = false;
          }
          
          const newStatus = isConnected ? 'connected' : 'disconnected';
          const currentSupabaseStatus = instance.status ? 'connected' : 'disconnected';
          
          if (currentSupabaseStatus !== newStatus) {
            const { error: updateError } = await supabase
              .from('instances')
              .update({ 
                status: isConnected,
                updated_at: new Date().toISOString()
              })
              .eq('id', instance.id);
            
            if (updateError) {
            }
          }
          
          await new Promise(resolve => setTimeout(resolve, 500));
          
        } catch (err) {
          
          try {
            await supabase
              .from('instances')
              .update({ 
                status: false,
                updated_at: new Date().toISOString()
              })
              .eq('id', instance.id);

          } catch (updateErr) {
          }
        }
      }
    } catch (err) {
    } finally {
      this.isSyncing = false;
    }
  }

  static async syncSingleInstance(instanceId: string): Promise<boolean> {
    try {
      const { data: instance, error } = await supabase
        .from('instances')
        .select('*')
        .eq('whatsapp', instanceId)
        .single();
      
      if (error || !instance) {
        return false;
      }
      
      const statusResult = await uazApiService.getInstanceStatus(instanceId);
      
      let isConnected = false;
      if (statusResult.success && statusResult.data?.instance) {
        isConnected = statusResult.data.instance.status === 'connected';
      }
      
      const currentSupabaseStatus = instance.status ? 'connected' : 'disconnected';
      const newStatus = isConnected ? 'connected' : 'disconnected';
      
      if (currentSupabaseStatus !== newStatus) {
        const { error: updateError } = await supabase
          .from('instances')
          .update({ 
            status: isConnected,
            updated_at: new Date().toISOString()
          })
          .eq('id', instance.id);
        
        if (updateError) {
          return false;
        }
      }
      
      return isConnected;
      
    } catch (err) {
      return false;
    }
  }

  static startAutoSync(intervalMinutes: number = 5): void {
    if (this.syncInterval) {
      return;
    }
    
    this.syncAllInstances();
    this.syncInterval = setInterval(() => {
      this.syncAllInstances();
    }, intervalMinutes * 60 * 1000);
  }

  static stopAutoSync(): void {
    if (this.syncInterval) {
      clearInterval(this.syncInterval);
      this.syncInterval = null;
    }
  }

  static isAutoSyncActive(): boolean {
    return this.syncInterval !== null;
  }
}

export const syncInstancesStatus = InstanceStatusSync.syncAllInstances.bind(InstanceStatusSync);
export const syncSingleInstanceStatus = InstanceStatusSync.syncSingleInstance.bind(InstanceStatusSync);